import React from "react"
import { Text } from "@chakra-ui/react"
import { asDateWithTZ } from "utilities/strings"

type Props = {
  date?: string;
  timezone: string;
}

const DateTimeCell = ({ date, timezone }: Props) => {
  if (!date) return null

  // Proxima Nova ships with tabular figures enabled by default in our Typekit
  // bundle, which makes 1's float in their own wide cell ("May 17" looks like
  // "May 1 7"). Force proportional digits on date cells where this is most
  // visible.
  return (
    <Text fontSize="sm" noOfLines={1} sx={{ fontVariantNumeric: "proportional-nums" }}>
      {asDateWithTZ(date, timezone, "MMM d, yyyy h:mm a")}
    </Text>
  )
}

export default DateTimeCell
